import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import QdtComponents from 'qdt-components';
import myUid from '../js/uid';

const options = {
  config: {
    host: 'sense-demo.qlik.com',
    secure: true,
    port: 443,
    prefix: '',
    appId: '04dc5010-d09d-4ee2-962c-e7cc6f6ce99b',
  },
  connections: {
    vizApi: true,
    engineApi: true,
    useUniqueSessionID: myUid,
  },
};

const qdtComponents = new QdtComponents(options.config, options.connections);

function QdtComponent({ type, props, setComponentPromise }) {
  const node = useRef(null);

  useEffect(() => {
    const componentPromise = qdtComponents.render(type, props, node.current);
    if (setComponentPromise) {
      setComponentPromise(componentPromise);
    }
  }, []);

  return (
    <div ref={node} />
  );
}

QdtComponent.propTypes = {
  type: PropTypes.string.isRequired,
  props: PropTypes.object.isRequired,
  setComponentPromise: PropTypes.func,
};
QdtComponent.defaultProps = {
  setComponentPromise: null,
};

export default QdtComponent;
